import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Card,
  Link,
  Container,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { RegisterForm } from '../sections/authentication/register';
import { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 4),
  padding: theme.spacing(5),
  backgroundColor: theme.palette.drawerBackground
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  // margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center'
  // padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Register() {
  const { state } = useLocation();

  return (
    <RootStyle title={`Signup | ${process.env.REACT_APP_PROJECTNAME}`}>
      <SectionStyle
        sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center' }}
      >
        <img src={process.env.REACT_APP_LOGO} alt="login" width={'80%'} />
      </SectionStyle>

      <Container maxWidth="sm" sx={{ marginTop: '10px' }}>
        <ContentStyle
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            padding: '20px 0px'
          }}
        >
          <RegisterForm role={state?.role} />
          <Typography
            variant="subtitle2"
            sx={{
              mt: 2,
              textAlign: 'center',
              mb: -2.6
            }}
          >
            Already have an account?&nbsp;
            <Link underline="hover" to="/login" component={RouterLink}>
              Login
            </Link>
          </Typography>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
